import Parse from "parse"
import { actionWithLoader } from "../Utils/utils"

export const addRecipesAndSectionsToEachProductionStep = () => {
  return actionWithLoader(async () => {
    await Parse.Cloud.run("addRecipesAndSectionsToEachProductionStep")
  })
}

export const addReusableProductionStepsToEachProductionStep = () => {
  return actionWithLoader(async () => {
    await Parse.Cloud.run("addReusableProductionStepsToEachProductionStep")
  })
}

export const fixReusableStepsPriorStepsSupplierItemsIndexes = () => {
  return actionWithLoader(async () => {
    await Parse.Cloud.run("fixReusableStepsPriorStepsSupplierItemsIndexes")
  })
}

/**
 * Should be run once after the migration to clean up the old migration data
 * @returns {Promise<void>}
 */
export const cleanUpReusableStepsAfterIndexesMigration = () => {
  return actionWithLoader(async () => {
    await Parse.Cloud.run("cleanUpReusableStepsAfterIndexesMigration")
  })
}